import axios from "axios"
import { handleError } from "../Helpers/ErrorHandler"
import { PartModel } from "../Models/PartModel";
import { MTB_PART_PICKER_API } from "../constants";


export const getComponentsAPI = async (id: number) => {
    try {
        const data = await axios.get<PartModel[]>(MTB_PART_PICKER_API + "/Components" + `/${id}`);
        return data;
    } catch (error) {
        handleError(error)
    }
};

export const getUserComponentsAPI = async (id: number) => {
    try {
        const data = await axios.get<PartModel[]>(MTB_PART_PICKER_API + "/UserComponents" + `/${id}`);
        return data;
    } catch (error) {
        handleError(error)
    }
};
